import React, {Component} from 'react';

import AgencyConnectionsConfigurationContent from "./AgencyConnectionsConfigurationContent";
import {withRouterParams} from "../../utils/withRouterParams";

class AgencyConnectionsConfiguration extends Component {
    getOnBoardingStatus() {
        if (this.props.location.state === undefined || this.props.location.state === null) {
            return false
        } else {
            return this.props.location.state.showOnBoarding
        }
    }

    render() {
        return (
            <AgencyConnectionsConfigurationContent agencyId={this.props.match.params.id}/>
        )
    }
}

export default withRouterParams(AgencyConnectionsConfiguration);

